module.exports = __webpack_public_path__ + "img/ssa-2.51afb2d1.svg";